import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

export const styles = StyleSheet.create({
  pageTitle: {
    textAlign: 'center',
    padding: '15px 0'
  },
  title: {
    color: colour.grey[100],
    fontSize: 24,
    fontWeight: 600,
    margin: 0,
    marginBottom: 5
  },
  subTitle: {
    color: colour.grey[300],
    fontSize: 14,
    fontWeight: 400,
    margin: 0
  }
});
